export default __webpack_public_path__ + "static/media/datang.575e5bff.jpg";